<template>
  <div id="app">
    <Header></Header>
    <router-view />
    <Footer></Footer>
    <Side></Side>
  </div>
</template>
<script>
import Header from './components/header.vue';
import Footer from './components/footer.vue';
import Side from './components/side.vue';
export default {
  components: {
    Header,
    Footer,
    Side,
  },
};
</script>
<style lang="less">
</style>
